//@flow

import React from 'react';
import { parse } from 'query-string';
import { withRouter } from 'react-router-dom';
import { Container, Col, Row } from 'reactstrap';

import LodgeLists from './LodgeLists';
import { LodgeSearchFormWrapper } from '../Common';

type Props = { location: { search: string } };

const LodgeListingsScreen = (props: Props) => {
  return (
    <Container>
      <Row>
        <Col xs="12" lg="12" xl="3">
          <LodgeSearchFormWrapper forMobile />
          <LodgeSearchFormWrapper />
        </Col>
        <LodgeLists {...parse(props.location.search)} />
      </Row>
    </Container>
  );
};

export default withRouter(LodgeListingsScreen);



// WEBPACK FOOTER //
// ./src/screens/Lodge/Listings/LodgeListingsScreen.js